export default function EuropeInfo() {
    return (
        <>
            {/* Main Colored Section */}
            <section className="w-full bg-[#C67B3E] py-12 px-4 sm:px-6 lg:px-16">
                <div className="max-w-7xl mx-auto text-center lg:text-left">
                    
                    <h3 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-white mb-6">
                        Best Europe Student Visa Consultant
                    </h3>

                    <div className="space-y-6 text-justify text-base sm:text-lg lg:text-xxl text-white/90 leading-relaxed max-w-8xl mx-auto lg:mx-0">

                        <p>
                            Dear Students, are you searching for a trusted Europe student visa consultant to guide you toward your dream of studying abroad?
                        </p>

                        <p>
                            Leave your worries behind and book a personalized consultation with our experienced Europe Education Consultants. Our professional expert team is dedicated to answering all your questions and providing step-by-step guidance to help you achieve your European study goals.
                        </p>

                        <p>
                            Whether you're planning to study in France, Italy, Germany, Belgium, or any other European country, we offer:
                        </p>

                        <ul className="list-disc pl-6 space-y-2">
                            <li>Tailored guidance based on your academic profile</li>
                            <li>Complete student visa assistance</li>
                            <li>Support for both formal and informal education pathways</li>
                            <li>Personalized travel and documentation planning</li>
                        </ul>

                        <p>
                            We have a highly empowered expert team equipped with in-depth industry knowledge — everything you need from a reliable student visa consultant to successfully achieve your goal of studying in Europe.
                        </p>

                        <p>
                            From Germany, Austria, and Poland to Italy, Norway, Finland, and many more, Europe offers students a wide range of exceptional study destinations. Europe is home to some of the world’s most prestigious colleges and universities:
                        </p>

                        <ul className="list-disc pl-6 space-y-2">
                            <li>Some institutions are globally recognized for technology and engineering</li>
                            <li>Others excel in business and management studies</li>
                            <li>Many are renowned for fashion, design, and creative arts</li>
                        </ul>

                        <p>
                            Students can choose the institute that best aligns with their career goals and build a successful future.
                        </p>

                        <p>
                            With the guidance of a trusted Europe Student Visa Consultant in Ahmedabad, you can simplify the visa process and increase your chances of securing approval for your chosen European country.
                        </p>

                        <p className="font-semibold">
                            Let our expertise turn your study abroad dream into reality.
                        </p>

                    </div>
                </div>
            </section>
        </>
    );
}